<template>
	<div class="flex flex-col w-full h-screen bg-gray-50 overflow-hidden font-sans">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 顶部搜索区域 -->
		<div class="flex-shrink-0 bg-white border-b border-gray-200 shadow-2xs z-10">
			<div class="w-full max-w-8xl mx-auto px-6 py-3.5">
				<div class="flex items-center justify-between gap-6">

					<div class="flex items-center flex-1 max-w-2xl gap-3">

						<div class="relative flex-1">
							<input type="text" v-model="searchQuery"
								class="w-full h-10 pl-10 pr-4 text-sm border border-gray-200 rounded-lg bg-white placeholder-gray-400 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all font-sans"
								:placeholder="$t('language000211')" />
							<i
								class="fas fa-search absolute left-3.5 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs"></i>
						</div>

						<!-- 搜素按钮 -->
						<div class="relative flex-shrink-0">
							<select v-model="selectedType"
								class="h-10 pl-4 pr-10 border border-gray-200 bg-white rounded-lg text-sm hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all cursor-pointer font-sans text-gray-700 appearance-none w-full">
								<option value="">
									{{ $t('language000212') }}
								</option>
								<option v-for="(type, index) in deviceTypes" :key="index" :value="type">
									{{ type }}
								</option>
							</select>

							<div
								class="absolute inset-y-0 right-3.5 flex items-center pointer-events-none text-gray-400">
								<i class="fas fa-chevron-down text-xs"></i>
							</div>
						</div>

					</div>

					<div class="flex items-center gap-3">
						<button @click="goToDeveloperInterface"
							class="flex items-center gap-2 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-md text-xs text-blue-600 font-medium whitespace-nowrap transition-all cursor-pointer">
							<i class="fas fa-code text-blue-500 text-xs"></i>
							<span class="tracking-wide">
								<!-- 最新的开发者界面 -->
								{{ $t('language000524') }}
							</span>
						</button>

						<div
							class="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-md text-xs text-gray-500 font-medium whitespace-nowrap">
							<i class="fas fa-microchip text-gray-400 text-xs"></i>
							<span class="tracking-wide">设备管理台</span>
						</div>
					</div>

				</div>
			</div>
		</div>


		<!-- 主要内容区域：作为一个弹性盒子（Flexbox）的子项，自动撑满剩余空间（flex-1），宽度满屏，超出部分允许垂直滚动 -->
		<div class="flex-1 w-full overflow-y-auto">

			<!-- 
				列表容器：
				- max-w-8xl mx-auto: 设置最大宽度为 8xl，并在大屏上水平居中对齐
				- px-6 py-6: 设定左右内边距为 24px（px-6），虽然 py-6 设定了上下内边距，但会被后面的更具体的样式覆盖
				- pt-4 pb-4: 覆盖 py-6 的上下设定，将顶部内边距（pt-4）和底部内边距（pb-4）精准缩减为 16px，使整体上下间距更紧凑
			-->
			<div class="max-w-8xl mx-auto px-6 py-6 pt-4 pb-4">

				<!-- 列布局容器：内部子项垂直排列（flex-col），子项之间的间距为 12px（gap-3） -->
				<div class="flex flex-col gap-3">

					<!-- 
						Vue 循环渲染：遍历过滤后的设备列表（filteredDevices），使用设备 id 作为唯一键（:key）
						样式解析：
						- flex flex-col lg:flex-row: 默认垂直排列（手机端），在大屏幕（lg）下切换为水平排列
						- items-center bg-white rounded-lg: 子项居中对齐，白色背景，大圆角
						- border border-gray-200 shadow-2xs: 浅灰色边框，微弱的阴影
						- hover:shadow-md hover:border-blue-200: 鼠标悬停时阴影加深，边框变成浅蓝色
						- transition-all duration-300: 开启全属性 300 毫秒的平滑过渡动画
						- p-4 group gap-6: 内边距 16px，声明为 group（方便子元素监听父级悬停），子项间距 24px
					-->
					<div v-for="device in filteredDevices" :key="device.id"
						class="flex flex-col lg:flex-row items-center bg-white rounded-lg border border-gray-200 shadow-2xs hover:shadow-md hover:border-blue-200 transition-all duration-300 p-4 group gap-6">

						<!-- 
							图片组合区域：
							- flex-shrink-0: 防止在空间不足时被压缩
							- w-full lg:w-40: 手机端宽度 100%，大屏下固定宽度 160px
							- justify-center lg:justify-start: 手机端居中对齐，大屏下靠左对齐
						-->
						<div
							class="flex items-center gap-3 flex-shrink-0 w-full lg:w-40 justify-center lg:justify-start">

							<!-- 
								主图容器：宽深 80px，浅灰背景，小圆角，居中展示图片
								- group-hover:scale-105: 当鼠标悬停在整个行卡片（group）上时，此图片放大 1.05 倍
							-->
							<div
								class="w-20 h-20 bg-gray-50 rounded-md p-1.5 flex items-center justify-center border border-gray-100 transition-transform duration-300 group-hover:scale-105">
								<!-- 绑定动态图片地址与设备名称，保持宽高比缩放（object-contain） -->
								<img :src="device.image" :alt="device.name"
									class="max-h-full max-w-full object-contain" />
							</div>

							<!-- 副图容器：宽深 64px，样式与主图类似，但不触发放大效果 -->
							<div
								class="w-16 h-16 bg-gray-50 rounded-md p-1.5 flex items-center justify-center border border-gray-100">
								<!-- 绑定第二张图片 -->
								<img :src="device.image01" :alt="device.name"
									class="max-h-full max-w-full object-contain rounded" />
							</div>
						</div>

						<!-- 
							设备信息区域（紧凑优化版）：
							- 从 grid 改为 flex 布局，使其在大屏下呈流式水平排列（lg:flex-row）
							- items-start lg:items-center: 手机端顶部对齐，大屏下垂直居中
							- gap-3 lg:gap-8: 手机端间距 12px，大屏下子项间距 32px（可根据需要调整为 gap-6 进一步缩紧）
						-->
						<div class="w-full flex-1 flex flex-col lg:flex-row items-start lg:items-center gap-3 lg:gap-8">

							<!-- 
								第一部分（设备名称与描述）：
								- lg:w-56 flex-shrink-0: 在大屏下固定一个合理的宽度（如 224px），防止撑大，同时不被其他元素压缩
							-->
							<div class="lg:w-56 flex-shrink-0 flex flex-col justify-center overflow-hidden">
								<!-- 设备名称：保持原有截断 -->
								<h3 class="text-sm font-bold text-gray-900 tracking-wide truncate max-w-[220px]"
									:title="device.name">
									{{ device.name }}
								</h3>
								<!-- 设备描述 -->
								<p class="text-xs text-gray-400 truncate max-w-[220px] mt-0.5 font-sans">
									{{ device.description }}
								</p>
							</div>

							<!-- 第二部分（状态标签）：flex-shrink-0 确保状态标签永远不会被挤压变形 -->
							<div class="flex-shrink-0 flex items-center">
								<span
									:class="device.status === $t('language000215') ? 'bg-green-50 text-green-600 border border-green-200' : 'bg-gray-100 text-gray-500 border border-gray-200'"
									:style="{ fontSize: '12px' }"
									class="px-2.5 py-0.5  font-medium rounded whitespace-nowrap">
									{{ device.status }}
								</span>
							</div>

							<!-- 
								第三部分（标签组）：
								- flex-1: 自动填满中间剩余的所有空间
								- gap-1.5: 稍微拉开一点标签与标签之间的间距，更精致
							-->
							<div class="flex-1 flex flex-wrap gap-1.5 items-center overflow-hidden">
								<span v-for="(tag, index) in device.tags" :key="index" :style="{ fontSize: '13px' }"
									class="px-1.5 py-0.5  bg-blue-50 text-blue-600 rounded font-medium whitespace-nowrap">
									{{ tag }}
								</span>
							</div>

						</div>

						<!-- 
							右侧操作区域（更新时间与详情按钮）：
							- w-full lg:w-auto: 手机端撑满，大屏下自适应宽度
							- justify-between lg:justify-end: 手机端两端对齐，大屏下靠右对齐
							- pt-3 lg:pt-0 border-t lg:border-t-0 border-gray-100: 手机端顶部带有 12px 内边距和一条浅灰分割线，大屏下移除分割线和内边距
						-->
						<div
							class="w-full lg:w-auto flex flex-row items-center justify-between lg:justify-end gap-6 flex-shrink-0 ml-auto pt-3 lg:pt-0 border-t lg:border-t-0 border-gray-100">

							<!-- 更新时间：内嵌 FontAwesome 时钟图标（far fa-clock），展示最后更新时间文本 -->
							<div class="text-xs text-gray-400 flex items-center whitespace-nowrap font-sans">
								<i class="far fa-clock mr-1.5 text-gray-300"></i>
								{{ device.lastUpdate }}
							</div>

							<!-- 去到新的开发者界面 -->
							<button v-if="device.showDevBtn" @click="goToDeveloperInterface"
								class="flex items-center gap-1.5 px-2 py-1 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded text-[11px] text-blue-600 font-medium whitespace-nowrap transition-all cursor-pointer focus:outline-none">
								<i class="fas fa-code text-blue-500 text-[10px]"></i>
								<span>{{ $t('language000524') }}</span>
							</button>

							<!-- 
								详情按钮：
								- @click="goToDetail(device.id)": 点击时触发 Vue 方法，跳转到对应 id 的详情页
								- focus:outline-none: 移除聚焦时的默认外边框
								- group/btn: 声明一个名为 btn 的自定义组，用于精准控制内部图标的联动动画
							-->
							<button @click="goToDetail(device.id)"
								class="text-blue-500 hover:text-blue-600 font-semibold text-xs flex items-center transition-colors focus:outline-none whitespace-nowrap group/btn">
								<!-- 从多语言配置文件中加载“查看详情”之类的文本 -->
								{{ $t('language000214') }}
								<!-- 
									右箭头图标：
									- group-hover/btn:translate-x-0.5: 当鼠标悬停在这个按钮（group/btn）上时，箭头向右平移 0.5个单位（约 2px）
									- transition-transform: 开启平移过渡动画
								-->
								<i
									class="fas fa-chevron-right text-[10px] ml-1 transform group-hover/btn:translate-x-0.5 transition-transform"></i>
							</button>
						</div>

					</div>

				</div>
			</div>
		</div>


		<!-- 页脚 -->
		<div class="flex-shrink-0 bg-white border-t border-gray-200 shadow-sm">
			<div
				class="w-full max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">

				<div class="text-xs text-gray-400">
					© 2026 OpenApi Equipment Hub. All rights reserved.
				</div>

				<div class="flex items-center gap-6">
					<button @click="goToErrorCode"
						class="flex items-center text-red-600 hover:text-red-700 font-medium text-xs transition-colors cursor-pointer hover:underline focus:outline-none whitespace-nowrap">
						<i class="fas fa-exclamation-circle mr-1 text-sm text-red-500"></i>
						<!-- 错误码中心 -->
						{{ $t('language000521') }}
					</button>

					<a href="#"
						class="text-gray-400 hover:text-gray-600 text-xs transition-colors hover:underline whitespace-nowrap">
						<i class="fas fa-book mr-1 text-gray-300"></i>
						<!-- 开发者文档 -->
						{{ $t('language000522') }}
					</a>
					<a href="#"
						class="text-gray-400 hover:text-gray-600 text-xs transition-colors hover:underline whitespace-nowrap">
						<i class="fas fa-headset mr-1 text-gray-300"></i>
						<!-- 技术支持 -->
						{{ $t('language000523') }}
					</a>
				</div>

				<div class="text-xs text-gray-400 font-mono hidden md:block">
					v2.4.0-stable
				</div>

			</div>
		</div>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				searchQuery: '',
				selectedType: '',
				showBackToTop: false,
				deviceTypes: [this.$t('language000220'), this.$t('language000221')], //钥匙盒，锁
				devices: [{
					id: 18,
					name: 'Pear Flower (II)',
					description: this.$t('language000508'), //二代肛塞
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000313'), this
						.$t('language000311')
					], //'开锁', '关锁', '震动', '电击'
					lastUpdate: '2026-4-13 10:00',
					image: require('../../../assets/anal_plug2_37.png'),
					image01: require('../../../assets/anal_plug2_3701.jpg'),
				}, {
					id: 15,
					name: 'CAGINK.metal.Shake',
					description: this.$t('language000454'), //震动金属锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t(
						'language000313')], //'开锁', '关锁', '震动'
					lastUpdate: '2025-11-25 14:00',
					image: require('../../../assets/tail20.png'),
					image01: require('../../../assets/gen_metal1601.png'),
				}, {
					id: 6,
					name: 'Key Pod (I)',
					description: this.$t('language000217'), //一代钥匙盒
					status: this.$t('language000215'), //已开放
					type: this.$t('language000220'), //钥匙盒
					tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
					lastUpdate: '2025-02-24 16:45',
					image: require('../../../assets/image_key_pod.png'),
					image01: require('../../../assets/image_key_pod01.jpg'),
				}, {
					id: 10,
					name: 'Cag Ink (III)',
					description: this.$t('language000304'), //三代锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000224'), this
						.$t('language000225')
					], //'开锁', '关锁', '蜂窝', '显示器'
					lastUpdate: '2024-02-25 12:15',
					image: require('../../../assets/image_cellmate_gen3.png'),
					image01: require('../../../assets/image_cellmate_gen301.png'),
					showDevBtn: true // 👈 只有配了这一行的 Item 才会显示按钮
				}, {
					id: 13,
					name: 'CAGINK.metal',
					description: this.$t('language000420'), //金属锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
					lastUpdate: '2025-05-01 10:00',
					image: require('../../../assets/gen_metal16.png'),
					image01: require('../../../assets/gen_metal1601.png'),
				},
				// {
				// 	id: 2,
				// 	name: 'Key Pod (II)',
				// 	description: this.$t('language000218'), //二代钥匙盒
				// 	status: this.$t('language000216'), //开发中
				// 	type: this.$t('language000220'), //钥匙盒
				// 	tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000224'), this
				// 		.$t('language000225')
				// 	], //'开锁', '关锁', '蜂窝', '显示器'
				// 	lastUpdate: '2024-12-31 16:45',
				// 	image: require('../../../assets/image_key_pod2.png'),
				// 	image01: require('../../../assets/image_key_pod201.png'),
				// }, {
				// 	id: 4,
				// 	name: 'Cag Ink (II)',
				// 	description: this.$t('language000219'), //二代锁
				// 	status: this.$t('language000216'), //开发中
				// 	type: this.$t('language000221'), //锁
				// 	tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
				// 	lastUpdate: '2024-01-20 12:15',
				// 	image: require('../../../assets/image_cellmate_gen2_cg.png'),
				// 	image01: require('../../../assets/image_cellmate_gen2_cg01.png'),
				// },
				]
			};
		},
		computed: {
			filteredDevices() {
				return this.devices.filter(device => {
					const matchesSearch = device.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
						device.description.toLowerCase().includes(this.searchQuery.toLowerCase());
					const matchesType = !this.selectedType || device.type === this.selectedType;
					return matchesSearch && matchesType;
				});
			}
		},
		methods: {
			// 处理点击最新的开发者界面跳转
			goToDeveloperInterface() {
				// 获取当前多语言的本地标识，并统一转为小写以防不规范
				const currentLocale = (this.$i18n.locale || 'zh-cn').toLowerCase();

				// 判断当前语言是否包含 'zh' (中文简体/繁体等)
				if (currentLocale.includes('zh')) {
					// 中文跳转链接
					window.open('https://s.apifox.cn/f4f4192a-eba2-4412-80e8-530b0a50a21b/9037703m0', '_blank');
				} else {
					// 其他语言跳转链接
					window.open('https://s.apifox.cn/722db2f7-9edc-4f3a-ab70-c1104ebaf719', '_blank');
				}
			},
			/**
			 * 新增方法：在新标签页中打开全部错误码页面
			 */
			goToErrorCode() {
				// 通过vue-router解析错误码页面路径
				let page = this.$router.resolve({
					path: '/ErrorCode',
					query: {}
				});
				// 在新标签页中打开该页面
				window.open(page.href, '_blank');
			},
			goToDetail(deviceId) {
				let page;
				switch (deviceId) {
					case 6: //一代钥匙盒
						page = this.$router.resolve({
							path: '/KeyBoxHome01',
							query: {}
						});
						window.open(page.href, '_blank');
						break
					case 10: //三代锁
						page = this.$router.resolve({
							path: '/Gen3Home',
							query: {}
						});
						break
					case 13: //金属锁
						page = this.$router.resolve({
							path: '/GenMetalHome',
							query: {}
						});
						break
					case 15: //震动金属锁
						page = this.$router.resolve({
							path: '/ShockGenMetalHome',
							query: {}
						});
						break
					case 18: //二代肛塞
						page = this.$router.resolve({
							path: '/Analplug2',
							query: {}
						});
						break
				}
				if (page != null) {
					window.open(page.href, '_blank');
				}
			},
			//...
		},
	};
</script>

<style scoped>
</style>